<template>
  <div class="container-fluid recover-password">
    <div class="row">
      <div class="col-10 offset-1 col-md-6 offset-md-3">
        <div class="mb-4 text-center">
          <img src="../assets/logo-02.png" class="img-fluid logo-img" alt="Plantsss">
          <p class="logo-text">GET FREE PLANTSSS</p>
          <div class="store-logo-container">
            <a v-bind:href="appstoreUrl" target="_blank">
              <img src="../assets/appstore.png"
                class="img-fluid store-logo" alt="Plantsss App Store">
            </a>
            <a v-bind:href="playstoreUrl" target="_blank">
              <img src="../assets/playstore.png"
                class="img-fluid store-logo" alt="Plantsss Play Store">
            </a>
          </div>
        </div>
      </div>
    </div>

    <form @submit="sendForm">
      <div v-if="!passwordChanged" class="row">
        <div class="col-10 offset-1 col-md-6 offset-md-3">
          <p class="text-center mt-4 color-plantsss">Volver a establecer contraseña</p>
        </div>

        <div class="col-10 offset-1 col-md-6 offset-md-3">
          <div class="form-group mt-4">
            <input
              v-model.trim="password"
              v-bind:class="{ 'is-invalid' : errors.password.length > 0 }"
              id="password" type="password" class="form-control"
              aria-describedby="passwordHelp" placeholder="Nueva Contraseña" required>

              <small v-if="errors.password.length > 0" id="errorHelp" class="form-text text-danger">
                {{ errors.password }}
              </small>
          </div>
          <div class="form-group mt-4">
            <input
              v-model.trim="passwordRepeat"
              v-bind:class="{ 'is-invalid' : errors.passwordRepeat.length > 0 }"
              id="passwordRepeat" type="password" class="form-control"
              aria-describedby="repeatRasswordHelp" placeholder="Repetir Nueva Contraseña" required>

              <small v-if="errors.passwordRepeat.length > 0"
                id="repeatRasswordHelp" class="form-text text-danger">
                {{ errors.passwordRepeat }}
              </small>
          </div>
        </div>

        <div class="col-10 offset-1 col-md-6 offset-md-3">
          <input type="submit" class="btn btn-plantsss" value="Enviar">
        </div>
      </div>

      <div v-if="passwordChanged" class="row">
        <div class="col-10 offset-1 text-center">
          <span class="color-plantsss see-mail mt-4 mb-4">
            ¡Cambio de contraseña realizado con éxito!
          </span>
          <span class="color-plantsss see-unwanted">
            Continua conociendo todo sobre tus plantas favoritas.
          </span>
          <span class="color-plantsss see-mail mt-4">
            <a v-bind:href="goToLink" class="color-plantsss">
              Ir a Plantsss
            </a>
          </span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
const axios = require('axios');

export default {
  name: 'NewPassword',
  data() {
    return {
      appstoreUrl: process.env.VUE_APP_APPSTORE_URL,
      playstoreUrl: process.env.VUE_APP_PLAYSTORE_URL,
      user: this.$route.params.user,
      hash: this.$route.params.hash,
      password: '',
      passwordRepeat: '',
      passwordChanged: false,
      errors: {
        password: '',
        passwordRepeat: '',
      },
      goToLink: 'https://plantsss.com',
    };
  },
  created() {
    document.title = 'Recuperar Contraseña | Plantsss';

    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.search('iphone') > -1) {
      this.goToLink = 'plantsss://password_updated';
    } else if (userAgent.search('android') > -1) {
      this.goToLink = 'intent://www.plantsss.cl/password_updated#Intent;scheme=http;package=com.nativecode.plantass;end;';
    }
  },
  methods: {
    sendForm(e) {
      e.preventDefault();

      this.errors.password = '';
      this.errors.passwordRepeat = '';

      if (this.password !== this.passwordRepeat) {
        this.errors.passwordRepeat = 'Contraseñas no coinciden';
        return;
      }

      const url = (process.env.NODE_ENV === 'production')
        ? `${process.env.VUE_APP_API_SERVER}/api/v1/user/new_password`
        : '/prod/api/v1/user/new_password';

      axios.post(url, {
        user: this.user,
        code: this.hash,
        password: this.password,
      })
        .then((response) => {
          const { status } = response.data;

          if (status !== 1) {
            this.errors.password = 'No es posible recuperar la contraseña';
          } else {
            this.passwordChanged = true;
          }
        })
        .catch(() => {
          this.errors.password = 'Ha ocurrido un error';
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .recover-password {
    min-height: 100vh;
    background-image: url('../assets/recover-password/bottom-background.png');
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center bottom;
    background-size: 90%;
    color: rgba(0, 0, 0, 0.87);

    .store-logo-container {
      position: relative;
      z-index: 1;
    }

    .logo-text {
      font-weight: 100;
      font-size: small;
      margin-top: -3em;
      width: 50%;
    }

    p {
      font-weight: 400;
      font-size: larger;
    }

    form {
      margin-top: 3em;

      input[type=submit] {
        color: #ffffff;
      }
    }

    .color-plantsss {
      color: #364832;
    }

    a:link {
      color: #364832;
    }

    span.see-mail {
      font-size: 1.5rem;
      font-weight: 400;
      line-height: 1.33;
      display: block;
    }

    span.see-unwanted {
      font-size: 1.5rem;
      font-weight: 300;
      line-height: 1.75;
    }

    .store-logo {
      width: 5em;
      float: left;
      padding-left: 0.5em;
      margin-top: -9px;
      z-index: 10;
    }
  }

  @media (min-width: 576px) {
    .recover-password {
      background-size: 50%;

      .logo-text {
        margin-top: -6em;
      }

      .store-logo-container {
        padding-left: 70px;

        .store-logo {
          width: 7em;
          height: auto;
        }
      }
    }
  }
</style>
